<template>
  <div>
    <EntryFeiWithdraw ref="entryWithdraw" />
    <EntryFeiHorseSelect ref="entrySpecifyHorseForSlot" />
    <EntryFeiApproveCandidacy ref="entryApproveCandidacy" />
    <EntryFeiReserveCandidacy ref="entryReserveCandidacy" />
    <EntryFeiRejectCandidacy ref="entryRejectCandidacy" />
    <EntryFeiUnregister ref="entryUnregister" />
    <EntryFeiReturnCandidacy ref="entryReturnToCandidacy" />
    <EntryFeiNotes ref="entryUpdateNotes" />
    <FeiHorseBeddingType ref="registrationHorseUpdateBeddingType" />
    <EntryFeiBillingContact ref="entryCreateOrUpdateBillingContact" />
    <EntryFeiOrderPayable ref="entryOrderProduct" />
    <EntryFeiEntryEdit ref="entryUpdateDetails" />
    <EntryFeiHorseSubstitute ref="registrationSubstituteHorses" />
    <EntryFeiAcceptEntry ref="entryAccept" />
    <EntryFeiRejectEntry ref="entryReject" />
    <EntryFeiReturnToWaiting ref="entryReturnToWaiting" />
    <EntryAthleteSubstitute ref="registrationSubstituteAthletes" />
    <EntryExternallyPaidDialog ref="entryUpdatePaidExternally" />
    <EntryConfirm ref="entryConfirm" />
    <EntryProductFee ref="entryAddRegistrationEventProduct" />
  </div>
</template>
<script>
export default {
  name: "EntryFeiActions"
};
</script>
<script setup>
import { useTemplateRef } from "vue";

import EntryFeiWithdraw from "./EntryFeiWithdraw.vue";
import EntryFeiHorseSelect from "./EntryFeiHorseSelect.vue";
import EntryFeiApproveCandidacy from "./EntryFeiApproveCandidacy.vue";
import EntryFeiReserveCandidacy from "./EntryFeiReserveCandidacy.vue";
import EntryFeiRejectCandidacy from "./EntryFeiRejectCandidacy.vue";
import EntryFeiUnregister from "./EntryFeiUnregister.vue";
import FeiHorseBeddingType from "./FeiHorseBeddingType.vue";
import EntryFeiReturnCandidacy from "./EntryFeiReturnCandidacy.vue";
import EntryFeiNotes from "./EntryFeiNotes.vue";
import EntryFeiBillingContact from "./EntryFeiBillingContact.vue";
import EntryFeiOrderPayable from "./EntryFeiOrderPayable.vue";
import EntryFeiEntryEdit from "./EntryFeiEntryEdit.vue";
import EntryFeiHorseSubstitute from "./EntryFeiHorseSubstitute.vue";
import EntryFeiAcceptEntry from "./EntryFeiAcceptEntry.vue";
import EntryFeiRejectEntry from "./EntryFeiRejectEntry.vue";
import EntryFeiReturnToWaiting from "./EntryFeiReturnToWaiting.vue";
import EntryAthleteSubstitute from "./EntryAthleteSubstitute.vue";
import EntryExternallyPaidDialog from "@/components/event/EventResults/ExternallyPaidDialog.vue";
import EntryConfirm from "./EntryConfirm.vue";
import EntryProductFee from "./EntryProductFee.vue";

const refs = {
  entryWithdraw: useTemplateRef("entryWithdraw"),
  entrySpecifyHorseForSlot: useTemplateRef("entrySpecifyHorseForSlot"),
  entryApproveCandidacy: useTemplateRef("entryApproveCandidacy"),
  entryReserveCandidacy: useTemplateRef("entryReserveCandidacy"),
  entryRejectCandidacy: useTemplateRef("entryRejectCandidacy"),
  entryUnregister: useTemplateRef("entryUnregister"),
  entryReturnToCandidacy: useTemplateRef("entryReturnToCandidacy"),
  entryUpdateNotes: useTemplateRef("entryUpdateNotes"),
  registrationHorseUpdateBeddingType: useTemplateRef(
    "registrationHorseUpdateBeddingType"
  ),
  entryCreateOrUpdateBillingContact: useTemplateRef(
    "entryCreateOrUpdateBillingContact"
  ),
  entryOrderProduct: useTemplateRef("entryOrderProduct"),
  entryUpdateDetails: useTemplateRef("entryUpdateDetails"),
  registrationSubstituteHorses: useTemplateRef("registrationSubstituteHorses"),
  entryAccept: useTemplateRef("entryAccept"),
  entryReject: useTemplateRef("entryReject"),
  entryReturnToWaiting: useTemplateRef("entryReturnToWaiting"),
  registrationSubstituteAthletes: useTemplateRef(
    "registrationSubstituteAthletes"
  ),
  entryUpdatePaidExternally: useTemplateRef("entryUpdatePaidExternally"),
  entryConfirm: useTemplateRef("entryConfirm"),
  entryAddRegistrationEventProduct: useTemplateRef(
    "entryAddRegistrationEventProduct"
  )
};

function openEntryFeiAction(ref, props) {
  refs[ref].value.openFeiActionForm(props);
}
defineExpose({ openEntryFeiAction });
</script>
